export default (props) => (props.if ? props.children : null);
